/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CommentsSectionSubscriptionVariables = {
    work_order_id: string;
    user_id: string;
};
export type CommentsSectionSubscriptionResponse = {
    readonly woOnlineUsers: {
        readonly type: string | null;
        readonly data: {
            readonly user_id: string | null;
        } | null;
    } | null;
};
export type CommentsSectionSubscription = {
    readonly response: CommentsSectionSubscriptionResponse;
    readonly variables: CommentsSectionSubscriptionVariables;
};



/*
subscription CommentsSectionSubscription(
  $work_order_id: String!
  $user_id: String!
) {
  woOnlineUsers(work_order_id: $work_order_id, user_id: $user_id) {
    type
    data {
      user_id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "user_id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "work_order_id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "user_id",
        "variableName": "user_id"
      },
      {
        "kind": "Variable",
        "name": "work_order_id",
        "variableName": "work_order_id"
      }
    ],
    "concreteType": "StatusMessage",
    "kind": "LinkedField",
    "name": "woOnlineUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Status",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "user_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsSectionSubscription",
    "selections": (v2/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentsSectionSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8dccecd4273c1198577ecae19bfb867d",
    "id": null,
    "metadata": {},
    "name": "CommentsSectionSubscription",
    "operationKind": "subscription",
    "text": "subscription CommentsSectionSubscription(\n  $work_order_id: String!\n  $user_id: String!\n) {\n  woOnlineUsers(work_order_id: $work_order_id, user_id: $user_id) {\n    type\n    data {\n      user_id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e1d25e656a1b61d7772bc31d4f4162c9';
export default node;
